// Movimientos de inventario hacia la contabilidad: datos que pide la pantalla al ingresar o ajustar stock.
// El envío lo hace el API (la llave del API contable nunca llega al navegador).

export type AccountingState = 'Enviado' | 'Pendiente' | 'Error' | 'Anulado';

export const accountingBadge: Record<AccountingState, string> = {
    Enviado: 'bg-success-subtle text-success-emphasis',
    Pendiente: 'bg-warning-subtle text-warning-emphasis',
    Error: 'bg-danger-subtle text-danger-emphasis',
    Anulado: 'bg-secondary-subtle text-secondary-emphasis',
};

export interface InventoryAccountingStatus {
    configured: boolean;
    active: boolean;
    activatedAt: string | null;
    pending: number;
    errors: number;
    initialTotal: number;
    initialSent: number;
}

/** Resumen corto del estado de la integración para la pantalla de inventario. */
export const accountingSummary = (status: InventoryAccountingStatus): string => {
    if (!status.active) return '';
    if (status.initialSent < status.initialTotal) {
        return `Contabilidad: enviando inventario inicial (${status.initialSent} de ${status.initialTotal} partes)`;
    }
    const parts = [
        status.pending > 0 ? `${status.pending} pendiente(s)` : null,
        status.errors > 0 ? `${status.errors} con error` : null,
    ].filter(Boolean);
    return parts.length > 0 ? `Contabilidad: ${parts.join(', ')}` : 'Contabilidad: al día';
};

/**
 * Botón "Enviar inventario inicial a contabilidad": se oculta solo cuando ya se envió (integración activa).
 * Si el servidor no tiene la integración configurada o no se pudo consultar, se muestra deshabilitado con el motivo.
 * status = undefined mientras se consulta; null si la consulta falló.
 */
export const initialInventoryButton = (status: InventoryAccountingStatus | null | undefined): { enabled: boolean; hint: string | null } | null => {
    if (status === undefined || status?.active) return null;
    if (status === null) return { enabled: false, hint: 'No se pudo consultar el estado de la integración con la contabilidad. Intente de nuevo más tarde.' };
    if (!status.configured) return { enabled: false, hint: 'La integración con la contabilidad no está configurada en el servidor (llave y URL del API contable).' };
    return { enabled: true, hint: null };
};
